var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPreroll = function SvgPreroll(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 55,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 54.667,
    height: 54.667,
    x: 0.667,
    y: 0.167,
    fill: "#061e21",
    rx: 27.333
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M42.333 25.643H43a.667.667 0 0 0-.684-.667zm-26.666.714-.018-.666a.667.667 0 0 0-.649.666zm0 4.286H15c0 .36.288.656.649.666zm26.666.714-.017.667a.667.667 0 0 0 .684-.667zm-8.501-4.856a.667.667 0 0 0-1.093-.765zm-4.426 3.998a.667.667 0 0 0 1.092.765zm12.91-5.523-26.667.715.036 1.333 26.666-.715zM15 26.357v4.286h1.333v-4.286zm.649 4.952 26.667.715.035-1.333-26.666-.715zM43 31.357v-5.714h-1.333v5.714zm-10.26-5.62-3.334 4.762 1.092.765 3.334-4.763zm-9.022-.035-3.81 4.763 1.04.833 3.811-4.763zm13.663-.06v5.715h1.334v-5.714z"
  })));
};
export default SvgPreroll;